import { useTranslation } from 'react-i18next';
import { startGitHubLogin } from '../net/api.js';
import { AppTitle } from './AppTitle.js';
import { CreditsLink } from './CreditsPanel.js';

const KNOWN_AUTH_ERRORS = new Set(['not-allowed', 'invalid-request', 'provider-error']);

/** Sign-in page: GitHub only, and only for people an admin has added (ADR-0004). */
export function LoginScreen({ authError }: { authError: string | undefined }) {
  const { t } = useTranslation();
  const errorKey = authError && KNOWN_AUTH_ERRORS.has(authError) ? authError : undefined;

  return (
    <main className="panel join">
      <AppTitle />
      <br />
      <button type="button" onClick={startGitHubLogin}>
        {t('login.github')}
      </button>
      {errorKey && (
        <p role="alert" className="error">
          {t(`login.errors.${errorKey}`)}
        </p>
      )}
      <p className="notice">{t('login.allowlistNotice')}</p>
      <CreditsLink />
    </main>
  );
}
